import room1 from './../assets/images/Rooms/room1.webp'
import room2 from './../assets/images/Rooms/room2.webp'
import room3 from './../assets/images/Rooms/room3.webp'
import room4 from './../assets/images/Rooms/room4.webp'
import room5 from './../assets/images/Rooms/room5.webp'

const PlanStay = () => {
  return (
    <div className='max-w-[1400px] m-auto py-16 px-8 mb-16 grid lg:grid-cols-2 gap-8 bg-gradient-to-r from-blue-100 to-blue-200 rounded-2xl shadow-lg'>
        <div className='grid grid-cols-2 grid-rows-6 h-[30vh] lg:h-[50vh] md:h-[40vh] z-20'>
            <img className='row-span-3 object-cover w-full h-full p-1 rounded-lg shadow-md' src={room1} alt="room 1" />
            <img className='row-span-2 object-cover w-full h-full p-1 rounded-lg shadow-md' src={room2} alt="room 2" />
            <img className='row-span-2 object-cover w-full h-full p-1 rounded-lg shadow-md' src={room3} alt="room 3" />
            <img className='row-span-3 object-cover w-full h-full p-1 rounded-lg shadow-md' src={room4} alt="room 4" />
            <img className='row-span-2 object-cover w-full h-full p-1 rounded-lg shadow-md' src={room5} alt="room 5" />
        </div>
        <div className='flex flex-col h-full justify-center'>
            <h3 className='text-5xl md:text-6xl font-bold leading-tight'>Plan Your Next Stay</h3>
            <p className='text-2xl py-6 leading-relaxed'>We have 7 luxurious en-suite rooms available at The Fox.</p>
            <p className='pb-6 text-lg leading-relaxed'>These rooms capture the delightful character of the building whilst incorporating an opulent and modern twist. With super-king size beds, deluxe bedding, stylish bathrooms, flat-screen TVs and a delicious cooked breakfast, you are guaranteed a relaxing and satisfying stay.</p>
            <div className='flex gap-4'>
                <a aria-label='Link to Rooms Page' href='/rooms'>
                  <button className='border-2 border-gray-700 text-gray-700 px-6 py-2 rounded-full hover:bg-gray-700 hover:text-white transition duration-300 shadow-md'>Learn More</button>
                </a>
                <a href='https://direct-book.com/properties/thefoxidirect?locale=en&items[0][adults]=2&items[0][children]=0&items[0][infants]=0&currency=GBP&checkInDate=2025-01-16&checkOutDate=2025-01-17&trackPage=no' aria-label='Link to Rooms Page'>
                  <button className='bg-gray-700 text-white px-6 py-2 rounded-full hover:bg-gray-800 transition duration-300 shadow-md'>Reserve Now</button>
                </a>
            </div>
        </div>
    </div>
  )
}

export default PlanStay